export default __webpack_public_path__ + "static/3169corevalues-936299971894d912d7bb6ce34df16df7.jpg";